<template>
	<div class="active-stage mb-5">

		<router-link class="title is-3 has-text-white stage-title mb-3" :to="'/session/'+movie_session.id+'/foyer'" style="display: block" v-if="!is_stopped && !is_ended">
			<template v-if="movie_session.title">
				{{ movie_session.title }}
			</template>
			<template v-else>
				{{ $t('session') }}{{ movie_session.movie_session_index }}
			</template>
		</router-link>

		<h1 class="title is-3 has-text-white stage-title mb-3" v-else>
			<template v-if="movie_session.title">
				{{ movie_session.title }}
			</template>
			<template v-else>
				{{ $t('session') }}{{ movie_session.movie_session_index }}
			</template>
		</h1>

		<div style="font-size: 1em;">
			<strong>
				{{ $t('movies:') }}
			</strong>
			<ol class="mb-3">
				<li class="ml-5" v-for="movie in movie_session.movies" :key="'movie_session_movies'+movie.id">
					{{ movie.title }}
				</li>
			</ol>

			<template v-if="not_started">
				<template v-if="past_due">
					<strong>
						{{ $t('session_will_start_soon') }}
					</strong>
				</template>
				<template v-else>
					<strong>
						{{ $t('will_start_in') }}
					</strong>
					<div class="has-text-left" style="font-size: 1.5em;" :class="[{ 'has-text-danger': expiring }]">
						{{ countdown }}
					</div>
				</template>
			</template>
			<template v-else-if="is_running">
				<strong v-html="$t('session_is_running')" />
			</template>
			<template v-else-if="is_ended">
				<strong v-html="$t('session_is_ended')" />
			</template>
			<template v-else-if="is_stopped">
				<strong v-html="$t('session_is_stopped')" />
			</template>

			<button type="button" class="button is-fullwidth is-light is-outlined mt-2" @click="register" v-if="movie_session.has_free_e_tickets">
				{{ $t('registration') }}
			</button>
			<div class="has-text-danger" style="font-size: 1.4em;" v-else>
				{{ $t('out_of_tickets') }}
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment'

export default{
	name: 'OnlineMovieSession',
	props: {
		movie_session: {
			required: true
		}
	},
	data(){
		return {
			countdown: null,
			TMID: null,
			expiring: false
		}
	},
	mounted(){
		if(this.timeLeft()){
			this.startTimer()
		}
	},
	computed: {
		// not_started
			// expiring
		// is_running
		// is_ended
		// is_stopped
		// is_opened - impossible cause we already closed registration
		// is_closed - impossible cause we already closed registration
		// past_due - if session not running but is overdue by start datetime
		not_started(){
			return !this.movie_session.started_at
		},
		is_running(){
			return this.movie_session.started_at && !this.movie_session.viewing_ended_at && !this.movie_session.stopped_at
		},
		is_ended(){
			return this.movie_session.started_at && this.movie_session.viewing_ended_at
		},
		is_stopped(){
			return this.movie_session.started_at && this.movie_session.stopped_at
		},
		is_opened(){
			return this.movie_session.opened_at && !this.movie_session.closed_at
		},
		is_closed(){
			return this.movie_session.opened_at && this.movie_session.closed_at
		},
		past_due(){
			return !this.timeLeft()
		}
	},
	methods: {
		register(){
			this.$router.push('/session/'+this.movie_session.id+'/foyer')
		},
		timeLeft(){
			var duration = moment.duration(moment(this.movie_session.start).diff(moment()));
			var seconds = duration.asSeconds();

			if(seconds < 0){
				clearInterval(this.TMID)
				return false
			}

			let format = 'HH:mm:ss'

			if(parseInt(seconds) > 86400){
				format = 'DD ['+this.$t('days')+'] HH:mm:ss'
			}
			this.countdown = moment.utc(seconds*1000).format(format)

			if(seconds == 120){
				this.expiring - true
			}

			return seconds
		},
		startTimer(){
			this.TMID = setInterval(() => {
				this.timeLeft()
			}, 1000)
		}
	}
}
</script>

<style>
.active-stage ol li::marker{
	color: #afafaf;
	font-size: 0.9em;
}
</style>